<template>
	<button
		type="button"
		ref="buttonRef"
		:class="buttonClasses"
		v-bind="{
			...attrs,
			...(props.size && props.size !== 'base' && { [props.size]: true }),
			...(props.border && { [props.border]: true }),
			...(props.isOutline && { outline: true }),
			...(props.isSoft && { soft: true }),
			...(props.isIconOnly && { iconOnly: true }),
			...(props.isActive && { active: true }),
			...(props.isLoading && { loading: true }),
			...(props.isRipple !== false && { ripple: true }),
			...(props.isDropdown && { dropdown: true }),
		}"
		:disabled="props.isDisabled"
		:aria-disabled="props.isDisabled || undefined"
		:aria-pressed="props.isToggle ? !!props.isActive : undefined"
		:aria-label="props.isIconOnly && typeof props.label === 'string' ? props.label : undefined"
		role="button"
	>
		<slot />
		<svg v-if="props.isDropdown" class="dropdown-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
			<path d="M7 10l5 5 5-5z" fill="currentColor" />
		</svg>
	</button>
</template>

<script>
import { computed, ref, useAttrs } from 'vue'

export default {
	name: 'AppButton',
	props: {
		variant: {
			type: String,
			validator: (value) => ['primary', 'secondary', 'accent', 'success', 'warning', 'danger', 'info', 'light', 'dark', 'link'].includes(value)
		},
		size: {
			type: String,
			default: '',
			validator: (value) => ['', 'xSmall', 'small', 'base', 'large', 'welcom'].includes(value)
		},
		border: {
			type: String,
			default: '',
			validator: (value) => ['', 'square', 'rounded', 'none', 'welcom'].includes(value)
		},
		isOutline: { type: Boolean, default: false },
		isSoft: { type: Boolean, default: false },
		isIconOnly: { type: Boolean, default: false },
		isActive: { type: Boolean, default: false },
		isToggle: { type: Boolean, default: false },
		isDisabled: { type: Boolean, default: false },
		isLoading: { type: Boolean, default: false },
		isRipple: { type: Boolean, default: true },
		label: { type: String, default: '' },
		isDropdown: { type: Boolean, default: false }
	},
	setup(props) {
		const attrs = useAttrs()
		const buttonRef = ref(null)

		const buttonClasses = computed(() => {
			const classes = ['app-btn']
			if (props.variant) {
				const base = props.isOutline ? 'app-btn-outline--' : 'app-btn--'
				classes.push(`${base}${props.variant}`)
			}
			return classes
		})

		// const handleRipple = (e) => {
		// 	const btn = buttonRef.value;
		// 	if (!btn) return;
		//
		// 	btn.querySelectorAll(".ripple").forEach((r) => r.remove());
		//
		// 	const circle = document.createElement("span");
		// 	circle.classList.add("ripple");
		//
		// 	const rect = btn.getBoundingClientRect();
		// 	const size = Math.max(rect.width, rect.height);
		// 	const x = e.clientX - rect.left - size / 2;
		// 	const y = e.clientY - rect.top - size / 2;
		//
		// 	circle.style.width = circle.style.height = `${size}px`;
		// 	circle.style.left = `${x}px`;
		// 	circle.style.top = `${y}px`;
		//
		// 	circle.addEventListener("animationend", () => circle.remove(), { once: true });
		//
		// 	requestAnimationFrame(() => {
		// 		btn.appendChild(circle);
		// 	});
		// };
		//
		// let rippleAttached = false;

		// watchEffect(() => {
		// 	const btn = buttonRef.value;
		// 	if (!btn) return;
		//
		// 	if (props.isRipple && !rippleAttached) {
		// 		btn.addEventListener("click", handleRipple);
		// 		rippleAttached = true;
		// 	} else if (!props.isRipple && rippleAttached) {
		// 		btn.removeEventListener("click", handleRipple);
		// 		rippleAttached = false;
		// 	}
		// });
		//
		// onBeforeUnmount(() => {
		// 	buttonRef.value?.removeEventListener("click", handleRipple);
		// });

		return {
			buttonRef,
			attrs,
			buttonClasses,
			props
		}
	}
}
</script>
